export default {
  'data_validator': {
    'required': 'El campo %name% no puede estar vacío',
    'min_length': 'El campo %name% debe tener como mínimo de caracteres %length%',
    'max_length': 'El campo %name% puede tener como máximo de caracteres %length%',
    'type': 'El campo %name% posee un formato incorrecto',
    'invalid_option': 'La opción seleccionada en el campo %name% es inválida',
    'numeric': {
      'smaller_than': 'El campo %name% debe ser menor a %number%',
      'greather_than': 'El campo %name% debe ser mayor a %number%'
    },
    'date': {
      'smaller_than': 'La fecha del campo %name% debe ser menor a la fecha de cierre',
      'greather_than': 'La fecha del campo %name% debe ser mayor a la fecha de inicio'
    },
    'file': {
      'format': 'El archivo que está tratando de subir posee un formato incorrecto (formatos permitidos %formats%)',
      'size': 'El archivo que está tratando de subir es muy pesado (peso máximo de %size% mb)'
    }
  },
  'calendar': {
    'month_names': {
      'january': 'ENE',
      'february': 'FEB',
      'march': 'MAR',
      'april': 'ABR',
      'may': 'MAY',
      'june': 'JUN',
      'july': 'JUL',
      'august': 'AGO',
      'september': 'SEP',
      'october': 'OCT',
      'november': 'NOV',
      'december': 'DIC'
    },
    'day_names_short': {
      'sunday': 'D',
      'monday': 'L',
      'tuesday': 'M',
      'wednesday': 'M',
      'thursday': 'J',
      'friday': 'V',
      'saturday': 'S'
    }
  },
  'errors': {
    'parse': {
      '101': 'El usuario o contraseña son incorrectos'
    },
    'custom': {
      '001': 'Ha ocurrido un error al enviar la petición, por favor te pedimos que intentes más tarde',
      '002': 'El código del cliente pertenece a otro cliente, porfavor ingresa otro código',
      '003': 'El usuario del vendedor no existe',
      '004': 'El campo del usuario del vendedor está vacío',
      '005': 'El campo del código del cliente está vacío',
      '006': 'Usted no posee los permisos suficientes para acceder',
      '007': 'El cif del cliente pertenece a otro cliente, porfavor ingresa otro cif'
    }
  },
  'views_names': {
    'public': {
      'login': 'Iniciar Sesión'
    },
    'private': {
      'sellers': {
        'list': 'Vendedores',
        'create': 'Vendedores',
        'delegations': 'Vendedores',
        'types': 'Vendedores'
      },
      'clients': {
        'list': 'Clientes'
      },
      'contracts': {
        'list': 'Contratos',
        'sda': 'Contratos'
      },
      'reports': {
        'master_data': 'Reportes',
        'sda': 'Reportes',
        'potential': 'Reportes',
        'cci': 'Reportes',
        'education': 'Reportes'
      }
    }
  },
  'public': {
    'login': {
      'title': 'Iniciar Sesión | Wella',
      'fields': {
        'username': 'usuario',
        'password': 'contraseña'
      },
      'login_button': 'Iniciar Sesión'
    }
  },
  'private': {
    'header': {
      'options': 'Opciones'
    },
    'aside': {
      'sellers': 'Vendedores',
      'clients': 'Clientes',
      'contracts': 'Contratos',
      'reports': 'Reportes',
      'logout': 'Salir'
    },
    'sellers': {
      'header': {
        'sellers_list': 'Listado',
        'sellers_delegations': 'Delegaciones',
        'sellers_types': 'Tipos'
      },
      'list': {
        'sellers_list': 'Listado de vendedores',
        'create_seller': 'Crear vendedor',
        'see_filters': 'Ver filtros',
        'export_users': 'Exportar vendedores',
        'please_wait': 'Por favor espera un momento',
        'filters': {
          'fullname': 'Nombre o apellido',
          'username': 'Nombre de usuario',
          'email': 'Correo electrónico',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'firstname': 'Nombres',
            'lastname': 'Apellidos'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'firstname': 'Nombres',
          'lastname': 'Apellidos',
          'username': 'Usuario',
          'email': 'Correo electrónico',
          'delegation': 'Delegación',
          'type': 'Tipo',
          'active': 'Activo',
          'active_yes': 'Si',
          'active_no': 'No',
          'last_access': 'Último acceso'
        },
        'menu_more_options': {
          'edit_seller': 'Editar vendedor',
          'delete_seller': 'Eliminar vendedor'
        },
        'sellers_list_create': 'Crear vendedor',
        'fields': {
          'firstname': 'nombres',
          'lastname': 'apellidos',
          'username': 'usuario',
          'email': 'correo electrónico',
          'password': 'contraseña',
          'delegation': 'Delegación',
          'seller_type': 'Tipo de vendendor',
          'active': 'Activo',
          'active_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'permissions': 'Permisos',
          'permissions_options': {
            'sellers': 'Vendedores',
            'clients': 'Clientes',
            'contracts': 'Contratos',
            'messages': 'Mensajes',
            'reports': 'Reportes',
            'master_data': '¿Es master data?'
          }
        },
        'create_button': 'Crear vendedor',
        'create_success': 'Vendedor creado con éxito',
        'sellers_update': 'Editar vendedor',
        'update_button': 'Editar vendedor',
        'update_success': 'Vendedor editado con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar este vendedor?'
        },
        'delete_success': 'Vendedor eliminado con éxito'
      },
      'delegations': {
        'sellers_delegations': 'Listado de delegaciones',
        'create_delegation': 'Crear delegación',
        'see_filters': 'Ver filtros',
        'filters': {
          'name': 'Nombre',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'name': 'Nombre'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'menu_more_options': {
          'edit_delegation': 'Editar delegación',
          'delete_delegation': 'Eliminar delegación'
        },
        'sellers_delegations_create': 'Crear delegación',
        'fields': {
          'name': 'nombre'
        },
        'create_button': 'Crear delegación',
        'create_success': 'Delegación creada con éxito',
        'sellers_delegations_update': 'Editar delegación',
        'update_button': 'Editar delegación',
        'update_success': 'Delegación editada con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar esta delegación?'
        },
        'delete_success': 'Delegación eliminada con éxito'
      },
      'sellers_types': {
        'sellers_types': 'Listado de tipos de vendedores',
        'create_seller_type': 'Crear tipo',
        'see_filters': 'Ver filtros',
        'filters': {
          'name': 'Nombre',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'name': 'Nombre'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'menu_more_options': {
          'edit_seller_type': 'Editar tipo',
          'delete_seller_type': 'Eliminar tipo'
        },
        'sellers_types_create': 'Crear tipo',
        'fields': {
          'name': 'nombre'
        },
        'create_button': 'Crear tipo',
        'create_success': 'Tipo de vendedor creado con éxito',
        'sellers_types_update': 'Editar tipo',
        'update_button': 'Editar tipo',
        'update_success': 'Tipo de vendedor editado con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar este tipo de vendedor?'
        },
        'delete_success': 'Tipo de vendedor eliminado con éxito'
      }
    },
    'clients': {
      'header': {
        'clients_list': 'Listado'
      },
      'list': {
        'clients_list': 'Listado de clientes',
        'create_client': 'Crear cliente',
        'import_clients': 'Importar clientes',
        'export_clients': 'Exportar clientes',
        'migrate_clients': 'Importar Migración',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'cif': 'CIF',
          'client_code': 'Código cliente',
          'email': 'Correo electrónico',
          'employees_quantity': 'Número de empleados',
          'lounges_quantity': 'Número de salones',
          'legal_name': 'Razón social',
          'discharge_date': 'Fecha alta',
          'status': 'Estado',
          'recruiting_lr': 'Contratación LR',
          'mkt_news': 'Novedades MKT',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'cif': 'CIF',
            'client_code': 'Código cliente',
            'email': 'Correo electrónico',
            'employees': 'Empleados',
            'lounge': 'Salón',
            'legal_name': 'Razón social',
            'discharge_date': 'Fecha alta',
            'status': 'Estado',
            'recruiting_lr': 'Contratación LR',
            'mkt_news': 'Novedades MKT'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'associated_accounts': 'Cuentas asociadas',
          'seller': 'Vendedor',
          'cfia': 'CFIA',
          'cif': 'CIF',
          'client_code': 'Código cliente',
          'delegation': 'Delegación',
          'email': 'Correo electrónico',
          'employees_quantity': 'Número de empleados',
          'lounges_quantity': 'Número de salones',
          'legal_name': 'Razón social',
          'discharge_date': 'Fecha alta',
          'status': 'Estado',
          'status_active': 'Activo',
          'status_inactive': 'Inactivo',
          'recruiting_lr': 'Contratación LR',
          'recruiting_lr_yes': 'Si',
          'recruiting_lr_no': 'No',
          'mkt_news': 'Novedades MKT',
          'mkt_news_yes': 'Si',
          'mkt_news_no': 'No',
          'image_conditions': 'Condiciones imagen',
          'image_conditions_yes': 'Si',
          'image_conditions_no': 'No'
        },
        'not_have_associated_accounts': 'Este cliente no posee cuentas asociadas',
        'menu_more_options': {
          'associate_account': 'Asociar cuenta',
          'see_associated_accounts': 'Listar cuentas asociadas',
          'edit_client': 'Editar cliente',
          'delete_client': 'Eliminar cliente'
        },
        'associate_account_modal': {
          'title': 'Asociar cuenta',
          'fields': {
            'client': 'buscar cliente',
            'legal_name': 'razón social',
            'cif': 'CIF',
            'email': 'correo electrónico'
          },
          'button': 'Asociar cuenta',
          'success': 'Cuenta asociada con éxito'
        },
        'associated_accounts_modal': {
          'title': 'Cuentas asociadas',
          'menu_more_options': {
            'delete_association': 'Eliminar asociación'
          },
          'question_modal': {
            'title': 'Advertencia',
            'question': '¿Está seguro que desea eliminar esta asociación?'
          },
          'delete_success': 'Asociación eliminada con éxito'
        },
        'import_clients_modal': {
          'title': 'Importar clientes por CSV',
          'import_clients': 'Importar clientes',
          'fields': {
            'separator': 'Separador',
            'separator_options': {
              'coma': ',',
              'semicolon': ';',
              'pipe': '|'
            },
            'csv': 'Cargar documento CSV'
          },
          'please_wait': 'Porfavor espera un momento',
          'clients_to_update': 'Clientes a modificar',
          'clients_to_create': 'Clientes a agregar',
          'clients_with_error': 'Clientes con errores',
          'no_clients_to_update': 'No hay clientes a modificar',
          'no_clients_to_create': 'No hay clientes a agregar',
          'no_clients_with_error': 'No hay clientes con errores',
          'table': {
            'seller': 'Vendedor',
            'client_code': 'Código del cliente',
            'legal_name': 'Razón social',
            'cif': 'CIF',
            'observation': 'Observación'
          },
          'no_data_to_import': 'Debes escoger al menos algún cliente para modificar o agregar',
          'import_success': 'Clientes importados con éxito'
        },
        'clients_list_create': 'Crear cliente',
        'fields': {
          'seller': 'vendedor',
          'cfia': 'CFIA',
          'cif': 'CIF',
          'client_code': 'código cliente',
          'email': 'correo electrónico',
          'employees_quantity': 'número de empleados',
          'lounges_quantity': 'número de salones',
          'legal_name': 'razón social',
          'receive_communications': 'Recibir comunicaciones',
          'receive_communications_options': {
            'receive_communications': 'Recibir comunicaciones'
          },
          'discharge_date': 'fecha alta',
          'status': 'estado',
          'status_options': {
            'active': 'Activo',
            'inactive': 'Inactivo'
          },
          'recruiting_lr': 'contratación LR',
          'recruiting_lr_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'mkt_news': 'novedades MKT',
          'mkt_news_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'conditions': 'Condiciones',
          'conditions_options': {
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          }
        },
        'create_button': 'Crear cliente',
        'create_success': 'Cliente creado con éxito',
        'clients_update': 'Editar cliente',
        'update_button': 'Editar cliente',
        'update_success': 'Cliente editado con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar este cliente?'
        },
        'delete_success': 'Cliente eliminado con éxito'
      }
    },
    'contracts': {
      'header': {
        'contracts_list': 'Contratos',
        'contracts_sda': 'SDA'
      },
      'list': {
        'contracts_list': 'Listado de contratos',
        'create_contract': 'Crear contrato',
        'export_contracts': 'Exportar contratos',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'since': 'Desde',
          'until': 'Hasta',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'client_code': 'Código del cliente',
          'legal_name': 'Razón social'
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'No OK',
            'pendiente_ok': 'Pendiente',
            'archive': 'Archivado',
            'retenido_asociado': 'Retenido x Asociado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'timestamp': 'Marca de tiempo',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'associated_1': 'Asociado 1',
          'associated_2': 'Asociado 2',
          'associated_3': 'Asociado 3',
          'associated_4': 'Asociado 4',
          'associated_5': 'Asociado 5',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Descuento',
          'wella_rappel': 'Rappel',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'Descuento',
          'sp_rappel': 'Rappel',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Descuento',
          'sebastian_rappel': 'Rappel',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Descuento',
          'sassoon_rappel': 'Rappel',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Descuento',
          'sp_diamond_rappel': 'Rappel',
          'nioxin_quantity': 'Nioxin',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_summer_discount': 'Desc. Verano',
          'nioxin_discount': 'Descuento',
          'nioxin_rappel': 'Rappel',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Descuento',
          'opi_rappel': 'Rappel',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial Diamond',
          'opi_potential': 'Potencial Opi',
          'wella_variable_discount': 'Wella Descuento Variable',
          'kolleston_growth': 'Crecimiento Kolleston',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'pdf': 'Ver PDF',
          'mail_conditions': 'Condiciones correo',
          'mail_conditions_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'image_conditions': 'Condiciones imagen',
          'image_conditions_options': {
            'yes': 'Si',
            'no': 'No'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea archivar este contrato?'
        },
        'contracts_list_create': 'Crear contrato',
        'client_not_have_relations': 'Este cliente no posee asociaciones',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial y descuentos',
        'observations': 'Observaciones',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'associate_accounts': 'Asociar cuentas',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Descuento',
          'wella_rappel': 'Rappel',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'Descuento',
          'sp_rappel': 'Rappel',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Descuento',
          'sebastian_rappel': 'Rappel',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Descuento',
          'sassoon_rappel': 'Rappel',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Descuento',
          'sp_diamond_rappel': 'Rappel',
          'nioxin_quantity': 'Nioxin',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_summer_discount': 'Desc. Verano',
          'nioxin_discount': 'Descuento',
          'nioxin_rappel': 'Rappel',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Descuento',
          'opi_rappel': 'Rappel',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial Diamond',
          'opi_potential': 'Potencial Opi',
          'wella_variable_discount': 'Wella Descuento Variable',
          'kolleston_growth': 'Crecimiento Kolleston',
          'wella_trade': 'Wella trade',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'pdf': 'Agregar archivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          }
        },
        'create_button': 'Crear contrato',
        'create_success': 'Contrato creado con éxito',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito'
      },
      'sda': {
        'sda_list': 'Contratos SDA',
        'create_contract_sda': 'Crear contrato SDA',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'exported': 'Exportado',
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'delegation': 'Delegación',
          'sda_sassoon': 'SDA Sassoon',
          'sda_sassoon_options': {
            'ok': 'ok'
          },
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_options': {
            'ok': 'ok'
          },
          'sda_sp': 'SDA System Professional',
          'sda_sp_options': {
            'ok': 'ok'
          },
          'sda_sp_men': 'SDA SP Men',
          'sda_sp_men_options': {
            'ok': 'ok'
          },
          'sda_sp_diamond': 'SDA SP Diamond',
          'sda_sp_diamond_options': {
            'ok': 'ok'
          },
          'sassoon_date': 'Sassoon Fecha',
          'sebastian_date': 'Sebastian Fecha',
          'sp_date': 'System Professional Fecha',
          'sp_men_date': 'SP Men Fecha',
          'sp_diamond': 'SP Diamond Fecha',
          'sda_date': 'SDA Fecha Ult',
          'normal_sda_pdf': 'SDA PDF',
          'diamond_sda_pdf': 'SDA SP Diamond PDF',
          'sda_link_pdf': 'Ver PDF'
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'create_contract_window': {
          'title': 'Crear contrato SDA',
          'fields': {
            'client': 'Cliente',
            'sda_types': 'Tipos de SDA',
            'sda_types_options': {
              'sda_sp': 'SDA SP',
              'sda_sp_men': 'SDA SP Men',
              'sda_sp_diamond': 'SDA SP DIamond',
              'sda_sebastian': 'SDA Sebastian',
              'sda_sassoon': 'SDA Sassoon'
            },
            'date': 'Fecha',
            'pdf': 'Agregar archivo PDF',
            'pdf_sp_diamond': 'Agregar archivo PDF Sp Diamond'
          },
          'create_button': 'Crear contrato SDA',
          'create_success': 'Contrato SDA creado con éxito'
        },
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito'
      }
    },
    'reports': {
      'header': {
        'master_data': 'Master Data',
        'sda': 'SDA',
        'potential': 'Potencial',
        'cci': 'CCI',
        'education': 'Educación'
      },
      'master_data': {
        'master_data_list': 'Reporte Master Data',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'export': {
          'no_data': 'Debes seleccionar al menos un contrato'
        },
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'groupings': {
          'name': 'Agrupar por:',
          'codeClient': 'Código Cliente',
          'legal_name': 'Razón Social',
          'seller': 'Vendedor'
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'associated_accounts': 'Cuentas asociadas',
          'associated_1': 'Asociado 1',
          'associated_2': 'Asociado 2',
          'associated_3': 'Asociado 3',
          'associated_4': 'Asociado 4',
          'associated_5': 'Asociado 5',
          'wella_total_discount': 'Wella descuento total',
          'wella_discount': 'Descuento Wella',
          'nioxin_summer_discount': 'Desc. Verano Nioxin',
          'nioxin_discount': 'Descuento Nioxin',
          'sp_discount': 'Descuento System Proffesional',
          'sebastian_discount': 'Descuento Sebastian',
          'sassoon_discount': 'Descuento Sassoon',
          'sp_diamond_discount': 'Descuento SP Diamond',
          'wella_quantity': 'Wella cantidad',
          'sebastian_quantity': 'Sebastian cantidad',
          'nioxin_quantity': 'Nioxin cantidad',
          'sp_quantity': 'System cantidad',
          'sassoon_quantity': 'Sassoon cantidad',
          'sp_diamond_quantity': 'SP Diamond cantidad',
          'wella_rappel': 'Wella Rappel',
          'sp_rappel': 'System P Rappel',
          'nioxin_rappel': 'Nioxin Rappel',
          'sebastian_rappel': 'Sebastian Rappel',
          'sassoon_rappel': 'Sassoon Rappel',
          'sp_diamond_rappel': 'SP Diamond Rappel',
          'observations': 'Observaciones',
          'timestamp': 'Marca de tiempo',
          'opi_quantity': 'OPI cantidad',
          'opi_discount': 'OPI descuento',
          'opi_rappel': 'OPI Rappel'
        }
      },
      'sda': {
        'sda_list': 'Reporte SDA',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'export': {
          'no_data': 'Debes seleccionar al menos un SDA'
        },
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'exported': 'Exportado',
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'delegation': 'Delegación',
          'sda_sassoon': 'SDA Sassoon',
          'sda_sebastian': 'SDA Sebastian',
          'sda_sp': 'SDA System Professional',
          'sda_sp_men': 'SDA SP Men',
          'sda_sp_diamond': 'SDA SP Diamond',
          'sassoon_date': 'Sassoon Fecha',
          'sebastian_date': 'Sebastian Fecha',
          'sp_date': 'System Professional Fecha',
          'sp_men_date': 'SP Men Fecha',
          'sp_diamond': 'SP Diamond Fecha',
          'sda_date': 'SDA Fecha Ult',
          'sda_pdf': 'Ver PDF SDA',
          'sda_sp_diamond_pdf': 'Ver PDF SDA SP Diamond',
          'normal_sda_pdf': 'SDA PDF',
          'diamond_sda_pdf': 'SDA SP Diamond PDF',
          'sda_link_pdf': 'Ver PDF'
        }
      },
      'potential': {
        'potential_list': 'Reporte Potencial',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'employees_quantity': 'Número de empleados',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial SP Diamond',
          'opi_potential': 'Potencial OPI'
        }
      },
      'cci': {
        'cci_list': 'Reporte CCI',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'client_code': 'Código cliente',
          'legal_name': 'Razón social',
          'image_conditions': 'Condiciones imagen'
        }
      },
      'education': {
        'education_list': 'Reporte Educación',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'No OK',
            'pendiente_ok': 'Pendiente',
            'archive': 'Archivado',
            'retenido_asociado': 'Retenido x Asociado'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'email': 'Correo electrónico',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'associated_1': 'Asociado 1',
          'associated_2': 'Asociado 2',
          'associated_3': 'Asociado 3',
          'associated_4': 'Asociado 4',
          'associated_5': 'Asociado 5',
          'wella_quantity': 'Wella cantidad',
          'wella_package': 'Paquete Wella',
          'sp_quantity': 'System cantidad',
          'sp_package': 'Paquete System',
          'nioxin_quantity': 'Nioxin cantidad',
          'nioxin_package': 'Paquete Nioxin',
          'sebastian_quantity': 'Sebastian cantidad',
          'sebastian_package': 'Paquete Sebastian',
          'sassoon_quantity': 'Sassoon cantidad',
          'sassoon_package': 'Paquete Sassoon',
          'salons': 'Salones',
          'mkt_news': 'Novedades MKT'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/es.js